<template>
  <main id="container" class="page-container bg-wave5 page-festival">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="지역행사" />
        </div>
      </div>
    </div>

    <!-- Desktop View -->
    <div v-if="!isMobile">
      <div class="page-content">
        <div class="container">
          <div class="page-sub-header">
            <h3 class="page-sub-title">
              <span class="prima green">동행축제와 함께 하는</span> 전국 행사를
              만나보세요.
            </h3>
          </div>
          <!-- Desktop Search -->
          <!-- <div class="category-search desktop-search mb-30"> ... </div> -->
          <!-- Desktop List -->
          <div class="exhibit-item-container">
            <img src="@/assets/img/event/festival2.jpg" />
            <!-- <ul v-if="arEventTabularList.length > 0" class="exhibit-item-list">
              <li
                class="exhibit-item-li"
                v-for="item in arEventTabularList"
                :key="item.idx"
                :class="{ 'is-closed': item.isClosed }"
              >
                <festival-item-list
                  :item="item"
                  @open-festival-modal="showFestivalModal"
                />
              </li>
            </ul> -->
            <!-- <in-ready v-else /> -->
          </div>
          <!-- Desktop Pagination -->
          <!-- <div class="pagination-wrap">
            <portal-pagination
              page-name="Festival"
              :total-count="pagingState.totalCount"
              :page-size="pagingState.pageSize"
              :page-no="pagingState.pageNo"
              :query="queries"
              :parent-method-name="'getArEventTabularList'"
              @getArEventTabularList="getArEventTabularList"
            ></portal-pagination>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Mobile View -->
    <section v-else class="msection">
      <div class="container">
        <!-- Mobile Search -->
        <!-- <div class="category-search mobile-search mb-20"> ... </div> -->

        <!-- Mobile List (Swiper) -->
        <div class="exhibit-item-container">
          <img src="@/assets/img/event/festival2.jpg" />
          <!-- <ul v-if="arEventTabularList.length > 0" class="exhibit-item-list">
            <li
              class="exhibit-item-li"
              v-for="item in arEventTabularList"
              :key="item.idx"
              :class="{ 'is-closed': item.isClosed }"
            >
              <festival-item-list
                :item="item"
                @open-festival-modal="showFestivalModal"
              />
            </li>
          </ul> -->
          <div
            v-if="arEventTabularList.length === 0 && !isLoading"
            class="no-data-message"
          >
            표시할 행사 정보가 없습니다.
          </div>
          <!-- 로딩 중 표시 (선택 사항) -->
          <div v-if="isLoading" class="loading-indicator">
            행사 정보를 불러오는 중...
          </div>

          <!-- Mobile Pagination -->
          <!-- <div v-if="totalPages > 0" class="mobile-page-controls">
            <div class="pagination-wrap">
              <portal-pagination
                page-name="mFestival"
                :total-count="pagingState.totalCount"
                :page-size="pagingState.pageSize"
                :page-no="pagingState.pageNo"
                :query="queries"
                :parent-method-name="'getArEventTabularList'"
                @getArEventTabularList="getArEventTabularList"
              ></portal-pagination>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <!-- FestivalModal 컴포넌트 -->
    <FestivalModal
      v-if="isModalVisible"
      :event-data="selectedEventData"
      @close="closeFestivalModal"
    />
  </main>
</template>

<script>
import Icon from "@/components/common/Icon";
import PageHeader from "@/components/content/PageHeader";
import PortalPagination from "@/components/PortalPaginationRoute";
import FestivalItemList from "@/components/content/FestivalItemList";
import FestivalModal from "@/components/content/FestivalModal.vue"; // FestivalModal import 추가
import InReady from "@/components/common/InReady";

// --- Swiper 관련 import 추가 ---
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css"; // Swiper CSS import

import { mapGetters } from "vuex";
import {
  ACT_GET_COMMON_CODE_LIST,
  ACT_GET_AR_EVENT_LIST,
} from "@/store/_act_consts";
import { MUT_SET_COMMON_CODE_ITEMS } from "@/store/_mut_consts";

import {
  lengthCheck,
  getItems,
  timestampToSeoulDateFormat,
  getCheckItems,
} from "@/assets/js/utils";

export default {
  name: "Festival2",
  components: {
    PageHeader,
    Icon,
    PortalPagination,
    FestivalItemList,
    FestivalModal,
    InReady,
    // --- Swiper 컴포넌트 등록 ---
    Swiper,
    SwiperSlide,
  },
  data: () => ({
    arDcdOptions: [],
    arEventList: [],
    arEventSrchFilter: {
      arDcd: null,
      arEventNm: "",
    },
    arEventTabularList: [],
    pagingState: {
      totalCount: 0,
      pageSize: 6, // 모바일 페이지 크기 기본값 설정 (예: 8)
      pageNo: 1,
    },
    isLoading: false,
    isModalVisible: false, // 모달 표시 여부
    selectedEventData: null, // 선택된 행사 데이터
    // --- Swiper 옵션 추가 ---
    swiperOption: {
      // loop: false, // 목록 끝에서 반복하지 않음
      slidesPerView: 1.5, // 한 화면에 1개 + 다음 항목 일부 보이도록 설정
      spaceBetween: 20, // 슬라이드 간격
      centeredSlides: true, // 활성 슬라이드를 가운데로
      // pagination: { // Swiper 자체 페이지네이션 사용 안 함
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },
      // navigation: { // Swiper 자체 네비게이션 버튼 사용 안 함
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
      breakpoints: {
        // 화면 크기별로 slidesPerView 조정 (선택 사항)
        // 375: { slidesPerView: 1.3 },
        // 480: { slidesPerView: 1.5 },
      },
    },
  }),
  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("festival", ["PAGING"]),
    campnId() {
      return this.campn.campnId;
    },
    queries() {
      let result = {};
      result.arEventNm = this.arEventSrchFilter.arEventNm;
      result.arDcd = this.arEventSrchFilter.arDcd;
      return result;
    },
    totalPages() {
      if (!this.pagingState.totalCount || this.pagingState.pageSize <= 0) {
        return 0;
      }
      return Math.ceil(this.pagingState.totalCount / this.pagingState.pageSize);
    },
  },
  watch: {
    arDcdOptions(newValue) {
      if (newValue.length > 0 && this.arEventList.length === 0) {
        this.getArEventList();
      }
    },
    isMobile(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pagingState.pageSize = newVal ? 6 : 6; // 모바일/PC 페이지 크기 조정
        this.getArEventList(); // 화면 모드 변경 시 데이터 다시 로드
      }
    },
    // --- arEventTabularList 변경 시 Swiper 업데이트 (선택 사항) ---
    arEventTabularList() {
      this.$nextTick(() => {
        const swiperInstance = this.$refs.festivalSwiper?.$swiper;
        if (swiperInstance && !swiperInstance.destroyed) {
          swiperInstance.update();
          if (this.isMobile && swiperInstance.slides && swiperInstance.slides.length > 0) {
            swiperInstance.slideTo(0, 0); // Go to the first slide without animation
          }
        }
      });
    },
    isModalVisible(isVisible) {
      if (isVisible) {
        // 스크롤바 너비 계산
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        document.body.style.paddingRight = `${scrollbarWidth}px`; // 스크롤바 너비만큼 패딩 추가
      } else {
        // 모달 닫힐 때 원래 상태로 복원
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    }
  },
  async created() {
    this.pagingState.pageSize = this.isMobile ? 6 : 6;
    await this.getCommonCdList();
  },
  mounted() {
    if (this.arDcdOptions.length > 0 && this.arEventList.length === 0) {
      this.getArEventList();
    }
  },
  methods: {
    onKeyUpSrch() {
      this.getArEventList();
    },
    onClickSrch() {
      this.getArEventList();
    },
    removeHhmmssFromYmd(ymd) {
      if (!ymd) return "";
      return ymd.substring(0, 10); // yyyy-MM-dd 형식으로 자르기
    },
    getDayNm(ymd) {
      if (!ymd) return "";
      const date = new Date(ymd);
      const days = ["일", "월", "화", "수", "목", "금", "토"];
      return days[date.getDay()];
    },
    formatDateForCompare(dateInput) {
      if (!dateInput) return null;
      try {
        let date;
        if (dateInput instanceof Date) {
          date = dateInput;
        } else if (typeof dateInput === "number") {
          date = new Date(dateInput);
        } else if (typeof dateInput === "string") {
          // 원본 문자열에서 앞 10자리 (YYYY-MM-DD)를 추출합니다.
          // 이는 API 응답 형식이 'YYYY-MM-DD' 또는 'YYYY-MM-DD HH:MM:SS' 등일 것으로 가정합니다.
          const dateOnlyString = dateInput.substring(0, 10);

          // Safari는 'YYYY/MM/DD' 형식을 'YYYY-MM-DD' 보다 안정적으로 파싱하는 경향이 있습니다.
          // "YYYY-MM-DD" -> "YYYY/MM/DD" 형태로 변경합니다.
          const parsableDateString = dateOnlyString.replace(/-/g, "/");

          date = new Date(parsableDateString);
        } else {
          console.error(
            "Unexpected date input type:",
            typeof dateInput,
            dateInput
          );
          return null;
        }

        // 유효한 Date 객체가 생성되었는지 확인합니다.
        if (isNaN(date.getTime())) {
          let processedInput = dateInput;
          if (typeof dateInput === 'string') {
            const dateOnlyString = dateInput.substring(0, 10);
            processedInput = dateOnlyString.replace(/-/g, "/");
          }
          console.error("Invalid Date created from input:", dateInput, "(processed as:", processedInput, ")");
          return null;
        }

        // YYYY-MM-DD 형식으로 변환합니다.
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      } catch (e) {
        console.error("Error formatting date:", dateInput, e);
        return null;
      }
    },
    async getCommonCdList() {
      const getArDcdOptions = () => {
        this.arDcdOptions = this.commonCode
          .filter((x) => x.dbColumn === "AR_DCD")
          .map((y) => ({ dcd: y.dcd, dcdVal: y.dcdVal }));
      };

      if (this.commonCode.length === 0) {
        try {
          const res = await this.$store.dispatch(
            `common/${ACT_GET_COMMON_CODE_LIST}`,
            {}
          );
          this.$store.commit(
            `common/${MUT_SET_COMMON_CODE_ITEMS}`,
            getCheckItems(res)
          );
          getArDcdOptions();
        } catch (error) {
          console.error("Error fetching common codes:", error);
        }
      } else {
        getArDcdOptions();
      }
    },
    async getArEventList() {
      this.isLoading = true;
      this.arEventTabularList = [];

      const modelAttr = {
        campnId: this.campnId,
        pageSize: 9999, // 전체 데이터를 가져옴
        pageNo: 1,
      };

      try {
        const res = await this.$store.dispatch(
          `festival/${ACT_GET_AR_EVENT_LIST}`,
          modelAttr
        );
        let rawEventList = [];

        if (lengthCheck(res)) {
          rawEventList = getItems(res);

          const filterNm = this.arEventSrchFilter.arEventNm?.toLowerCase();
          const filterArDcd = this.arEventSrchFilter.arDcd;

          let filteredList = rawEventList.filter((item) => {
            const nameMatch =
              !filterNm || item.arEventNm?.toLowerCase().includes(filterNm);
            const areaMatch = !filterArDcd || item.arDcd === filterArDcd;
            return nameMatch && areaMatch;
          });

          const todayStr = this.formatDateForCompare(new Date());

          const processedList = filteredList.map((item) => {
            const bgngYmd = this.removeHhmmssFromYmd(item.eventBgngYmd); // 화면 표시용
            const bgngDayNm = this.getDayNm(bgngYmd);
            const endYmd = this.removeHhmmssFromYmd(item.eventEndYmd); // 화면 표시용
            const endDayNm = this.getDayNm(endYmd);

            // 정렬 및 상태 비교용 날짜 (수정된 formatDateForCompare 사용)
            const startDateStr = this.formatDateForCompare(item.eventBgngYmd);
            const endDateStr = this.formatDateForCompare(item.eventEndYmd);

            let isClosed = false,
              isOngoing = false,
              isFuture = false;

            // startDateStr, endDateStr, todayStr 중 하나라도 null이면 비교를 수행하지 않도록 방어 코드 추가
            if (startDateStr && endDateStr && todayStr) {
              isClosed = todayStr > endDateStr;
              isOngoing = todayStr >= startDateStr && todayStr <= endDateStr;
              isFuture = todayStr < startDateStr;
            } else {
              // 날짜 파싱 실패 시, 기본적으로 '종료됨' 또는 다른 상태로 처리할 수 있으나,
              // 여기서는 상태 플래그를 false로 두고 정렬 시 null을 고려하도록 함
              // 또는 console.warn 등으로 로그를 남겨 데이터 문제를 인지할 수 있도록 함
              console.warn("Date parsing failed for item:", item.idx, "bgng:", item.eventBgngYmd, "end:", item.eventEndYmd);
            }

            const arNm =
              this.arDcdOptions.find((dcd) => dcd.dcd === item.arDcd)?.dcdVal ||
              "-";
            return {
              ...item,
              arNm: arNm,
              date: `${bgngYmd} (${bgngDayNm}) ~ ${endYmd} (${endDayNm})`,
              isClosed,
              isOngoing,
              isFuture,
              startDateStr, // 정렬에 사용
              endDateStr,   // 정렬에 사용될 수 있음 (현재는 isClosed 조건에만 사용)
            };
          });

          processedList.sort((a, b) => {
            // isOngoing, isFuture 상태 우선 정렬
            if (a.isOngoing && !b.isOngoing) return -1;
            if (!a.isOngoing && b.isOngoing) return 1;
            if (a.isFuture && !b.isFuture) return -1;
            if (!a.isFuture && b.isFuture) return 1;

            // 같은 상태 내에서는 startDateStr로 정렬
            // null 값 방어: startDateStr이 null일 경우 비교에서 오류 발생 방지
            const aDate = a.startDateStr;
            const bDate = b.startDateStr;

            if (aDate === null && bDate === null) return 0;
            if (aDate === null) return 1; // null을 뒤로 보내는 경우 (오래된 날짜로 간주)
            if (bDate === null) return -1; // null을 뒤로 보내는 경우

            if (a.isOngoing && b.isOngoing) { // 진행 중: 시작일 오름차순
              return aDate.localeCompare(bDate);
            }
            if (a.isFuture && b.isFuture) { // 예정: 시작일 오름차순
              return aDate.localeCompare(bDate);
            }
            if (a.isClosed && b.isClosed) {
              // 종료된 행사: 시작일 오름차순 (주석 "종료된 행사는 시작일 오름차순")
              // 기존 코드: b.startDateStr.localeCompare(a.startDateStr) (시작일 내림차순)
              // 주석을 따르려면 아래와 같이 변경:
              return aDate.localeCompare(bDate);
              // 만약 최신 종료 순으로 하고 싶다면 endDateStr 기준 내림차순: b.endDateStr.localeCompare(a.endDateStr)
            }
            return 0;
          });

          this.arEventList = processedList;
          this.pagingState.totalCount = this.arEventList.length;
          this.getArEventTabularList(1);
        } else {
          this.arEventList = [];
          this.arEventTabularList = [];
          this.pagingState.totalCount = 0;
          this.pagingState.pageNo = 1;
        }
      } catch (error) {
        console.error("Error fetching or processing AR Event list:", error);
        this.arEventList = [];
        this.arEventTabularList = [];
        this.pagingState.totalCount = 0;
        this.pagingState.pageNo = 1;
      } finally {
        this.isLoading = false;
      }
    },
    getArEventTabularList(pageNum = this.pagingState.pageNo) {
      this.pagingState.pageNo = pageNum;
      const fullList = this.arEventList; // 전체 목록 사용
      const pageSize = this.pagingState.pageSize;
      const startIndex = (pageNum - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      this.arEventTabularList = fullList.slice(startIndex, endIndex); // 현재 페이지에 해당하는 목록만 잘라냄

      if (this.isMobile) {
        window.scrollTo(0, 0);
      }
    },
    showFestivalModal(eventData) {
      this.selectedEventData = eventData;
      this.isModalVisible = true;
    },
    closeFestivalModal() {
      this.isModalVisible = false;
      this.selectedEventData = null;
    },
  },
  metaInfo() {
    return {
      title: "지역행사2",
      link: [
        {
          rel: "canonical",
          href: "https://www.k-shoppingfesta.org/ko/festival2",
        },
        {
          rel: "alternate",
          hreflang: "ko",
          href: "https://www.k-shoppingfesta.org/ko/festival2",
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: "https://www.k-shoppingfesta.org/ko/festival2",
        },
      ],
    };
  }
};
</script>

<style scoped>
::v-deep.exhibit-item-li  .item-content{
  border: 1px solid #eaeaea;
  border-radius: 20px;
  padding: 20px;
  background:#fff
}

::v-deep.exhibit-item-li .item-content-info-coupon-img img {
  border-radius: 20px;
  width: 100%;
  height: auto;
  object-fit: cover;
  height: 515px;
}
::v-deep.exhibit-item-li.is-closed .coupon-img-thumb {
  position: relative;
  display: block;
}

::v-deep.exhibit-item-li.is-closed .coupon-img-thumb::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 20px;
}

::v-deep.exhibit-item-li.is-closed .coupon-img-thumb::after {
  content: "종료된 행사입니다.";
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  line-height: 1.3;
  padding: 0 1em;
  white-space: pre-wrap;
  word-break: keep-all;
}

@media screen and (max-width: 768px) {
  ::v-deep .exhibit-item-li .item-content-info-coupon-img img {
    min-height: unset;
    height: auto !important;
    max-height:unset !important
  }

  ::v-deep .exhibit-item-li.is-closed .coupon-img-thumb::before,
  ::v-deep .exhibit-item-li.is-closed .coupon-img-thumb::after {
    border-radius: 16px;
  }
}

/* --- 모바일 스타일 추가 --- */
.msection {
  padding: 20px 0;
  /* overflow-x: hidden; */
}
.msection .container {
  padding: 0 15px;
}

/* 모바일 검색창 */
.category-search.mobile-search {
  margin-bottom: 20px;
}
.category-search .category-search-area {
  max-width: none;
  height: 48px;
  border-width: 1px;
}
.category-search .category-search-input {
  font-size: 14px;
}
.category-search .category-search-input::placeholder {
  font-size: 14px;
}
.category-search .category-search-button {
  padding: 0 12px;
}
.category-search .category-search-button .icon {
  width: 20px;
  height: 20px;
  padding: 0;
}
.category-search .category-search-button .icon img {
  position: static;
  width: 100%;
  height: 100%;
  transform: none;
}

/* --- 모바일 목록 (Swiper) --- */
.exhibit-item-container.mobile-list {
  margin-bottom: 20px; /* 페이징과 간격 */
  margin-left: -50px;
}
.festival-swiper {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
.festival-slide {
  width: 80%; /* 슬라이드 너비 조정 (slidesPerView에 따라 자동 계산될 수도 있음) */
  /* FestivalItemList 컴포넌트가 슬라이드 크기에 맞게 조정되도록 */
  display: flex;
  justify-content: center;
  align-items: stretch; /* 높이 꽉 차게 */
  box-sizing: border-box;
  opacity: 0.7; /* 비활성 슬라이드 투명도 */
  transition: opacity 0.3s, transform 0.3s;
}
.swiper-slide-active.festival-slide {
  opacity: 1;
  transform: scale(1);
  z-index: 1;
}
/* FestivalItemList 내부 스타일 조정 필요 시 */
.festival-slide > :deep(.exhibit-item) {
  /* FestivalItemList의 루트 요소 선택 */
  width: 100%; /* 슬라이드 너비에 맞춤 */
  height: 100%; /* 슬라이드 높이에 맞춤 */
  margin: 0; /* 불필요한 마진 제거 */
}

/* 모바일 페이징 */
.mobile-page-controls {
  display: flex;
  height: 36px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 46px;
}
.page-nav-button {
  display: flex;
  width: 36px;
  height: 36px;
  padding: 0;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #555;
  border-radius: 50%;
  border: 1px solid #eaeaea;
  background: #fff;
  cursor: pointer;
}
.page-nav-button:hover:not(:disabled) {
  background-color: #f5f5f5;
}
.page-nav-button:disabled {
  color: #ccc;
  border-color: #eee;
  cursor: not-allowed;
  background: #f9f9f9;
}
.page-info {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  border-radius: 18px;
  border: 1px solid #e0e0e0;
  background: #fff;
  height: 36px;
  display: inline-flex;
  align-items: center;
  padding: 0 15px;
  justify-content: center;
  min-width: 70px;
  box-sizing: border-box;
}
.page-info .current-page {
  font-weight: 700;
  color: #008775;
}
.page-info .separator {
  margin: 0 5px;
  color: #ccc;
}
.page-info .total-pages {
  color: #888;
}

/* 데이터 없음 메시지 */
.no-data-message {
  text-align: center;
  padding: 40px 0;
  color: #888;
  font-size: 14px;
}
/* 로딩 인디케이터 스타일 (선택 사항) */
.loading-indicator {
  text-align: center;
  padding: 40px 0;
  color: #888;
  font-size: 14px;
}

/* 데스크톱 검색창 여백 조정 */
/* .desktop-search { ... } */
</style>
